import 'ui-core/plugins/scrollo/js/scrollo';
(function () {
    var scrollo = {
        init: function () {
            $('.anchor-spacer').remove();
            scrollo.control();
        },
        adjustAnchor: function (target) {
            var $anchor = $(target);
            var $headerHeight = $('header').outerHeight();

            if ($('.coolBar.stickybar').length) $headerHeight += $('.coolBar.stickybar').outerHeight();
            $(document).scrollTop($anchor.offset().top - $headerHeight);
        },
        control: function () {
            $(document).on('click', "a[href^='#']", function (e) {
                if ($(this).attr('href') !== '#' && $('.article__body ' + $(this).attr('href')).length > 0) {
                    e.preventDefault();
                    scrollo.adjustAnchor($(this).attr('href'));
                    return false;
                }
            });
        },
    };

    UX.scrollo = scrollo; // add to global namespace
})();
